/**
 * Takes a string and returns a sanitized version of the string
 *
 * @param text input string
 */
export function textToId(text: string) {
  return (text.match(/[a-zA-Z]+/g) || ['blog-section'])
    ?.join('-')
    .toLocaleLowerCase();
}

export function flattenNodeText(node: {
  content: Array<{ nodeType: string; value: string }>;
  nodeType: string;
}) {
  return node.content
    .filter(node => node.nodeType === 'text')
    .reduce((text, textNode) => text + textNode.value, '');
}
